<div class="modal-header">
  <h4 class="modal-title">Edit Individual Event Waitlists Filters</h4>
  <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body">

  <div class="form-group clearfix">
    <button type="button" class="btn btn-primary float-right ml-2"
            (click)="handleSubmit()">
      Apply
    </button>
    <button type="button" class="btn btn-secondary float-right"
            (click)="handleClearAll()">
      Clear All
    </button>
  </div>

  <ng-container *ngIf="locationService.getLocations().length > 1">
    <hr>

    <div class="form-group">
      <button type="button" class="btn btn-outline-primary btn-sm float-right"
              (click)="filters.location_id = accountService.getMyAccount().default_gym_id;">
        Clear
      </button>

      <div class="row">
        <div class="col-12 pl-0">
          <label for="location_id">Location</label>

          <select class="custom-select"
                  id="location_id"
                  name="location_id"
                  [(ngModel)]="filters.location_id">
            <option [ngValue]="undefined">All</option>
            <option *ngFor="let location of locationService.getLocations()"
                    [ngValue]="location.id">
              {{ location.name }}
            </option>
          </select>
        </div>
      </div>
    </div>
  </ng-container>

  <hr>

  <div class="form-group">
    <button type="button" class="btn btn-outline-primary btn-sm float-right"
            (click)="filters.event_type_id = undefined;">
      Clear
    </button>

    <div class="row">
      <div class="col-12 pl-0">
        <label for="event_type_id">Event Type</label>

        <select class="custom-select"
                id="event_type_id"
                name="event_type_id"
                [(ngModel)]="filters.event_type_id">
          <option [ngValue]="undefined">All</option>
          <option *ngFor="let eventType of eventTypes"
                  [ngValue]="eventType.id">
            {{ eventType.name }}{{ eventType.status === EventTypeStatus.retired ? ' (Retired)' : '' }}
          </option>
        </select>
      </div>
    </div>
  </div>

  <hr>

  <div class="form-group">
    <button type="button" class="btn btn-outline-primary btn-sm float-right"
            (click)="filters.first_start_min = undefined;filters.first_start_max = undefined;">
      Clear
    </button>

    <label class="d-block">Event Start Date</label>

    <div class="row mx-0 mt-2">
      <div class="col-6 pl-0">
        <label for="first_start_min">On or after</label>
        <app-date-picker [id]="'first_start_min'"
                         [content]="filters.first_start_min"
                         (contentChange)="filters.first_start_min = $event"></app-date-picker>
      </div>
      <div class="col-6 pr-0">
        <label for="first_start_max">On or before</label>
        <app-date-picker [id]="'first_start_max'"
                         [content]="filters.first_start_max"
                         (contentChange)="filters.first_start_max = $event"></app-date-picker>
      </div>
    </div>

    <small class="form-text text-muted">
      Leave both blank to list events that have not yet started.
    </small>
  </div>

  <hr>

  <div class="form-group">
    <button type="button" class="btn btn-outline-primary btn-sm float-right"
            (click)="filters.has_active_waitlist = undefined;">
      Clear
    </button>

    <label class="d-block">Waitlist</label>

    <div class="form-check">
      <input class="form-check-input" type="checkbox"
             id="show_all_events"
             name="show_all_events"
             [ngModel]="filters.has_active_waitlist === false"
             (ngModelChange)="setShowAllEvents($event)">
      <label class="form-check-label" for="show_all_events">
        Show every event in the date range, including events with no waiting or pending entries
      </label>
    </div>
  </div>

</div>

<div class="modal-footer">
  <button type="button" class="btn btn-secondary"
          (click)="handleClearAll()">
    Clear All
  </button>
  <button type="button" class="btn btn-primary"
          (click)="handleSubmit()">
    Apply
  </button>
</div>
